<aside class="sidebar shadow-sm">

  <div class="sidebar-profile d-flex flex-column justify-content-center pt-2 pb-2">
    <!-- Profile with photo starts-->
    <!--<div class="picture-wrapper mb-2">
      <div class="user-picture m-auto">
        <img src="./assets/img/user.jpg" class="img-fluid" alt="">
      </div>
    </div>-->
    <div class="picture-wrapper mb-1">
      <div class="user-picture m-auto">
        <div id="upload_button">
        <label>
        <input type="file"  (change)="selectProfilePic($event,userProfile.userName)" visbility="hidden" />
          <img *ngIf="!userProfile.profilePicUrl" src="./assets/img/user.jpg" style="cursor:pointer" class="rounded-circle" alt="profile" height="60" width="60">
          <img *ngIf="userProfile.profilePicUrl" src="{{userProfile.profilePicUrl}}" style="cursor:pointer" class="rounded-circle" height="60" width="60" alt="profile">
        </label>
        </div>
      </div>
    </div>
    
    <div class="profile-details text-center pb-2">
      <p class="mb-0 name">{{userProfile.ownerName}}</p>
      <p class="mb-0 name" style="color:rgb(228, 133, 25);">{{userProfile.userRole}}</p>
      <span class="role">Last Login: {{userProfile.lastLogin | date: dateTimeFormat}}</span>
    </div>
    
    <!-- Profile with photo ends-->
    
  </div>
  <div class="sidebar-search pt-1 pb-1 pl-3 pr-3">
    <input type="search" class="form-control rounded-pill" name="search" placeholder="Search ...">
  </div>
  <nav class="sidebar-menu pt-1 pb-1" *ngIf="session">
    <ul class="menu-items">
      <li >
        <a href="#" routerLink="/admin/dashboard" routerLinkActive="active">
          <!--<i class="fas fa-home" style="font-size:18px"></i>-->
          <i class="material-icons" style="font-size:20px">dashboard</i>
          <span >Dashboard</span>
          <!--<span class="badge badge-warning rounded-0 text-dark p-1">NEW</span>-->
        </a>
      </li>
      
      <!--<li>
        <a href="#" routerLink="/admin/branch" routerLinkActive="active" [class.disabled]="!(subscriptionService.hasFeature('BRANCH') | async)">
          <i class="fas fa-hdd" style="font-size:20px"></i>
          <span>Branches</span>   
          &nbsp;<i *ngIf="!(subscriptionService.hasFeature('BRANCH') | async)" class="fa fa-lock" style="font-size:14px; color: red;"></i>       
        </a>
      </li>--> 
      <li>
        <a href="#" routerLink="/admin/branch" routerLinkActive="active" [class.disabled]="!featureJson.BRANCH">
          <i class="far fa-building" style="font-size:20px"></i>
          <span>Branches</span>   
          &nbsp;<i *ngIf="!featureJson.BRANCH" class="fa fa-lock" style="font-size:14px; color: red;"></i>       
        </a>
      </li>
      
      
      <!------------------Masterdata Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-school" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('master',masterMenu)">Master Data</span>
          <i *ngIf="!masterMenu" (click)="toggleFlag('master',masterMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="masterMenu" (click)="toggleFlag('master',masterMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="masterMenu">
        <!--<li>
          <a href="#" routerLink="/admin/branch" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Institute Branch**</span>        
          </a>
        </li>--> 
        <li>
          <a href="#" routerLink="/admin/session" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Sessions</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/board" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Boards and Exams</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/stream" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Streams</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/classcourse" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Classe or Course</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/section" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Section or Batch</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/subject" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Subjects</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/grade" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Mark Grades</span>        
          </a>
        </li>
        
        <!--<li>
          <a href="#" routerLink="/admin/leavetype" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Type**</span>        
          </a>
        </li>--> 
        <li>
          <a href="#" routerLink="/admin/holiday" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Holiday</span>        
          </a>
        </li> 
        <!--<li>
          <a href="#" routerLink="/admin/department" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Department</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/designation" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Designation</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/admin/template" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Templates</span>        
          </a>
        </li> 
        <!--<li >
          <a href="#" routerLink="/admin/template" routerLinkActive="active" [class.disabled]="false">
            <i class="fas fa-hdd" style="font-size:20px"></i>
            <span>Templates</span>&nbsp;
          </a>
        </li>-->
      </span>

      <!------------------Global Setting Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('setting',settingMenu)">Global Setting</span>
          <i *ngIf="!settingMenu" (click)="toggleFlag('setting',settingMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="settingMenu" (click)="toggleFlag('setting',settingMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="settingMenu">  
        <li>
          <a href="#" routerLink="/admin/setting" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">General Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/setting/paymentgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Payment Gateway</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/setting/emailgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Email Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/setting/cloud" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Cloud Provider</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/setting/smsgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">SMS Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/setting/whatsappgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Whatsapp Setting</span>        
          </a>
        </li>
        <!--<li>
          <a href="#" routerLink="/admin/setting" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Modules</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/useraccess" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">User Permission**</span>        
          </a>
        </li> -->
      </span>  
      <!------------------Payroll Master Menu Category----------------------->
      <li >
        <a routerLinkActive="active"><!--[class.disabled]="!(subscriptionService.hasFeature('FEE') | async)"-->
          <i class="fa fa-credit-card" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('feeMgmt',feeMgmtMenu)">Fee Management</span>
          <!--&nbsp;<i *ngIf="!(subscriptionService.hasFeature('FEE') | async)" class="fa fa-lock" style="font-size:14px; color: red;"></i>-->

          <i *ngIf="!feeMgmtMenu" (click)="toggleFlag('feeMgmt',feeMgmtMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="feeMgmtMenu" (click)="toggleFlag('feeMgmt',feeMgmtMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="feeMgmtMenu">        
        <!--<li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Group/Slab</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/admin/fee" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Type</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/fee/setup" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Master/Assign</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/fee/details" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Details</span>        
          </a>
        </li>
        <!--<li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Discount</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Collect Fee/Update</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Search Fee</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Carry Forward</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Reminder</span>        
          </a>
        </li>
      </span>
      <!------------------Payroll Master Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-money-check-alt" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)">Payroll Management</span>
          <i *ngIf="!payrollMgmtMenu" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="payrollMgmtMenu" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="payrollMgmtMenu">        
        <li>
          <a href="#" routerLink="/admin/payroll/masterallowance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Master Allownce</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/payroll/employeeallowance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Employee Allownce</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/payroll/masterdeduction" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Master Deduction</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/payroll/employeededuction" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Employee Deduction</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/payroll/salarystack" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Salary Stack</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/payroll/salary" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Process Payroll</span>        
          </a>
        </li>
      </span>
      <!------------------Accounting Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-hand-holding-usd" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('accounting',accountingMenu)">Accounting</span>
          <i *ngIf="!accountingMenu" (click)="toggleFlag('accounting',accountingMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="accountingMenu" (click)="toggleFlag('accounting',accountingMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="accountingMenu">
        <li>
          <a href="#" routerLink="/admin/accounting/bankAcct" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Bank Account</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/accounting" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Income & Expense</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/accounting/incomeHead" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Income Head</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/accounting/expenseHead" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Expense Head</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/accounting/income" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Income</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/accounting/expense" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Expense</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/accounting/cashtrans" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Cash Transaction</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/accounting/vendor" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Vendor</span>        
          </a>
        </li>        
      </span>
      <!------------------Library Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-book-open" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('library',libraryMenu)">Library Management</span>
          <i *ngIf="!libraryMenu" (click)="toggleFlag('library',libraryMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="libraryMenu" (click)="toggleFlag('library',libraryMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="libraryMenu">
        <li>
          <a href="#" routerLink="/admin/library/book" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Books</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/library/member" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Member & Card</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/library/cardHolder" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Issue Return Books</span>        
          </a>
        </li>
      </span>
      <!------------------Inventory Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="far fa-object-group" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('inventory',inventoryMenu)">Inventory</span>
          <i *ngIf="!inventoryMenu" (click)="toggleFlag('inventory',inventoryMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="inventoryMenu" (click)="toggleFlag('inventory',inventoryMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="inventoryMenu">
        <li>
          <a href="#" routerLink="/admin/inventory/category" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Category</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/inventory/item" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Items</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/inventory/supplier" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Supplier</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/inventory/store" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Store Detail</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/inventory/stock" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Item Stock</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/inventory/issueItem" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Issue Item</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/inventory/saleItem" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Sales Order</span>        
          </a>
        </li>
      </span>
      <!------------------Reception Desk Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-stream" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('crm',crmMenu)">Reception Desk</span>
          <i *ngIf="!crmMenu" (click)="toggleFlag('crm',crmMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="crmMenu" (click)="toggleFlag('crm',crmMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="crmMenu">        
        <li>
          <a href="#" routerLink="/admin/enquiry" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admission Enquiry</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/admission/crm" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admissions CRM</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/admission/bulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admission Bulk</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/enquiry/addBulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Campaign Data Upload</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/enquiry/visitor" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Visitors</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/enquiry/complain" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Complains</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/enquiry/postal" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Postal</span>        
          </a>
        </li>
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-user-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('student',studentMenu)">Students</span>
          <i *ngIf="!studentMenu" (click)="toggleFlag('student',studentMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="studentMenu" (click)="toggleFlag('student',studentMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="studentMenu">  
        <li>
          <a href="#" routerLink="/admin/addStudent" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">New Student</span>        
          </a>
        </li>       
        <li>
          <a href="#" routerLink="/admin/students" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Details</span>        
          </a>
        </li>  
        
        <li>
          <a href="#" routerLink="/user/tracker" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Scores and Analytics</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/studentdoc/certificate" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Transfer Certificate</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/studentdoc/icard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Identity Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/studentdoc/admitcard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Exam Admit Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/studentdoc/award" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Award Certificate</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/students/promote" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Class Promotion</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/students/enable" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enable Student</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/students/past" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Old Students</span>         
          </a>
        </li>
      </span>
      <!------------------AUTOMATIONS Menu Category----------------------->
      <!------------------Student Attendance Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-calendar-check" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('attendance',attendanceMenu)">Student Attendance</span>
          <i *ngIf="!attendanceMenu" (click)="toggleFlag('attendance',attendanceMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="attendanceMenu" (click)="toggleFlag('attendance',attendanceMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="attendanceMenu">        
        <li>
          <a href="#" routerLink="/admin/attendance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/attendance/view" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">View Attendance</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/attendance/view" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">QRCode Attendance</span>        
          </a>
        </li>
        
        <li>
          <a href="#" routerLink="/admin/leave" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Requests</span>        
          </a>
        </li>
      </span>
      
      <!------------------Transport Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-bus-alt" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('transport',transportMenu)">Transport</span>
          <i *ngIf="!transportMenu" (click)="toggleFlag('transport',transportMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="transportMenu" (click)="toggleFlag('transport',transportMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="transportMenu">        
        <li>
          <a href="#" routerLink="/admin/vehicle" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Vehicle</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/busroute" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Bus Route</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/busroute/students" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Route Students</span>        
          </a>
        </li>
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <!------------------Online Examination----------------------->
      <li >
        <a routerLinkActive="active" [class.disabled]="!featureJson.ONLINE_EXAM">
          <i class="fas fa-rss" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('test_exam',testMenu)">Online Exam</span>
          &nbsp;<i *ngIf="!featureJson.ONLINE_EXAM" class="fa fa-lock" style="font-size:14px; color: red;"></i>

          <i *ngIf="!testMenu" (click)="toggleFlag('test_exam',testMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="testMenu" (click)="toggleFlag('test_exam',testMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="testMenu">        
        <li>
          <a href="#" routerLink="/admin/questionbank" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Question Bank</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/questionbank/bulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">QBank Bulk</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/onlineexam" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Online Exam</span>        
          </a>
        </li>
      </span>
      <!------------------Offline Examination----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-layer-group" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('offline_exam',offlineExamMenu)">Offline Exam</span>
          <i *ngIf="!offlineExamMenu" (click)="toggleFlag('offline_exam',offlineExamMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="offlineExamMenu" (click)="toggleFlag('offline_exam',offlineExamMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="offlineExamMenu">        
        <li>
          <a href="#" routerLink="/admin/offlineexam" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Offline Exams</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/offlineexam/schedule" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Exam Schedules</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/offlineexam/marksheet" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Marksheet</span>        
          </a>
        </li>
      </span>
      <!------------------Notificaton Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-bullhorn" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('notification',notificationMenu)">Communications*</span>
          <i *ngIf="!notificationMenu" (click)="toggleFlag('notification',notificationMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="notificationMenu" (click)="toggleFlag('notification',notificationMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="notificationMenu">        
        <li>
          <a href="#" routerLink="/admin/notice" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Notification</span>        
          </a>
        </li>   
        <li>
          <a href="#" routerLink="/admin/message/template" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Message Template</span>        
          </a>
        </li>     
        <li>
          <a href="#" routerLink="/admin/message/send" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fas fa-shipping-fast" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Send Message</span>         
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/admin/message/log" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Message Log</span>         
          </a>
        </li>
        
      </span>     
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-sitemap" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('staff',staffMenu)">Human Resource</span>
          <i *ngIf="!staffMenu" (click)="toggleFlag('staff',staffMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="staffMenu" (click)="toggleFlag('staff',staffMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="staffMenu">        
        <li>
          <a href="#" routerLink="/admin/staff" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Staff Directory</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/addStaff" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Staff</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/department" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Department</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/designation" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Designation</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/leavetype" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Type</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/leavetype/setup" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Master</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/leave" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Report</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/leave/history" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave History</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/attendance" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/attendance/report" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance Report</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staffdoc/letter" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Letters</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staffdoc/icard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Identity Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/enable" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enable Staff</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/staff/past" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Old Staffs</span>         
          </a>
        </li>
      </span>
      <!------------------AUTOMATIONS Menu Category----------------------->  
      <li >
        <a href="#" routerLink="/admin/parent" routerLinkActive="active">
          <i class="fas fa-user-friends" style="font-size:18px"></i>
          <span>Parents</span>         
        </a>
      </li>
      <!------------------AUTOMATIONS Menu Category----------------------->
      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-graduation-cap" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('academic',academicMenu)">Academics</span>
          <i *ngIf="!academicMenu" (click)="toggleFlag('academic',academicMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="academicMenu" (click)="toggleFlag('academic',academicMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="academicMenu">        
        <li>
          <a href="#" routerLink="/admin/academic/chapter" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Chapters</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/academic/topic" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Topics</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/academic/syllabus" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Syllabus Status</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/admin/academic/video" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Video Tutorial</span>        
          </a>
        </li>   
        <li>
          <a href="#" routerLink="/admin/timetable" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Time Table</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/admin/homework" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Home Work</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Lession Plan</span>        
          </a>
        </li>    
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a href="#" routerLink="/admin/liveclass/gmeet" routerLinkActive="active">
          <i class="fas fa-video" style="font-size:18px"></i>
          <span>GMeet Live Class</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/admin/liveclass/zoom" routerLinkActive="active">
          <i class="fas fa-video" style="font-size:18px"></i>
          <span>Zoom Live Class</span>         
        </a>
      </li>
      <!------------------Report Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-chart-line" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('report',reportMenu)">Reports</span>
          <i *ngIf="!reportMenu" (click)="toggleFlag('report',reportMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="reportMenu" (click)="toggleFlag('report',reportMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="reportMenu">        
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Payment Report</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Performance</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Retention</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Teacher Retention</span>        
          </a>
        </li>   
      </span>
      <!------------------Report Menu Category----------------------->

      <li >
        <a href="#" routerLink="/admin/sample" routerLinkActive="active" [class.disabled]="false">
          <i class="fas fa-hdd" style="font-size:20px"></i>
          <span>Samples</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/admin/sample/calendar" routerLinkActive="active">
          <i class="fas fa-calendar" style="font-size:20px"></i>
          <span>Calendar</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/admin/chart" routerLinkActive="active">
          <i class="fas fa-chart-pie" style="font-size:20px"></i>
          <span>Charts</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/admin/externalexam" routerLinkActive="active">
          <i class="fas fa-rss" style="font-size:20px"></i>
          <span>External Exam</span>          
        </a>
      </li>
      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-user-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('aiagent',aiAgentMenu)">AI Agents</span>
          <i *ngIf="!aiAgentMenu" (click)="toggleFlag('aiagent',aiAgentMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="aiAgentMenu" (click)="toggleFlag('aiagent',aiAgentMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="aiAgentMenu">  
        <li>
          <a href="#" routerLink="/admin/aiagent/chatbot" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enquiry Chatbot</span>        
          </a>
        </li>
      </span> 

      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Hostel Management</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Alumni</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Study Materials</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Promo Codes</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Event Gallery</span>         
        </a>
      </li>
      
    </ul>
    
    <!--<div class="menu-header mt-4 mb-4">
      Github Repo
    </div>
    <div class="view-source mb-3">
      <a href="https://github.com/azouaoui-med/lightning-admin-angular" target="_blank" class="btn btn-block btn-lightning rounded-0">View Source</a>
    </div>  --> 
  </nav>
</aside>